import { Box } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { useDisclosure } from '@mantine/hooks'
import { FormattedMessage } from 'react-intl'
import { IntegrationInputHandler } from '@/components/integrations/IntegrationInputHandler/IntegrationInputHandler'
import { IntegrationListItem } from '@/components/integrations/IntegrationListItem/IntegrationListItem'
import { CodeSnippet } from '@/components/ui-shared/CodeSnippet/CodeSnippet'
import { EventDestination } from '@/types/deployment'
import { FormValues } from '../IntegrationSelection'
import { integrationConfig } from '../config'
import { CodeExampleToggle } from './CodeExampleToggle'
import { API_JSON_EXAMPLE } from './json-examples/api-json-example'

type RestApiIntegrationProps = {
  deviceId: string
  form: UseFormReturnType<FormValues>
  disabled?: boolean
}

export const RestApiIntegration = ({
  deviceId,
  form,
  disabled
}: RestApiIntegrationProps) => {
  const isSelected = form.getValues().integrations.restApi.isSelected
  const [isJsonExampleOpen, { toggle: toggleJsonExample }] =
    useDisclosure(false)

  return (
    <IntegrationListItem
      checkboxId="restApi"
      isSelected={isSelected}
      disabled={disabled}
      title={
        <FormattedMessage
          id={integrationConfig[EventDestination.CustomApi].name}
        />
      }
      description={
        <FormattedMessage
          id={integrationConfig[EventDestination.CustomApi].description}
        />
      }
      logoSrc={integrationConfig[EventDestination.CustomApi].logo}
      showDetails={isSelected}
      contentWidth={600}
      onChange={(value) => {
        form.setFieldValue('integrations.restApi.isSelected', value)
        form.clearErrors()
      }}
    >
      <IntegrationInputHandler
        {...form.getInputProps('integrations.restApi.endpointUrl')}
        label={<FormattedMessage id="integrations.endpointUrl" />}
        placeholder="https://api.your-domain.com/events"
        deviceId={deviceId}
        source={EventDestination.CustomApi}
        isTestButtonDisabled={!form.isValid(`integrations.restApi.endpointUrl`)}
      />

      <Box mt="lg">
        <CodeExampleToggle
          buttonLabel={<FormattedMessage id="integrations.jsonExample" />}
          isOpen={isJsonExampleOpen}
          onClick={toggleJsonExample}
        >
          <CodeSnippet maxHeight={400} copyValue={API_JSON_EXAMPLE}>
            {API_JSON_EXAMPLE}
          </CodeSnippet>
        </CodeExampleToggle>
      </Box>
    </IntegrationListItem>
  )
}
